module.exports = __webpack_public_path__ + "img/Exchangee.408e60c5.svg";